import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { EarningReportListResponse } from '../model/response/earning-report-list.response';
import { MonthlyDeliveryIncomeResponse } from '../model/response/monthly-delivery-income.response';
import { MonthlyIncomeRequest } from '../model/request/monthly-income.request';

@Injectable()
export class AdminOnTradeSettingApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchSetting(userId) {
    return this.http.get<any>(
      this.baseUrl + '/api/cf/administration/registration/' + userId + '/on-trade-setting',
      {headers: this.getAuthHeaders()}
    );
  }

  public create(userId, request) {
    return this.http.post<any>(
      this.baseUrl + '/api/cf/administration/registration/' + userId + '/on-trade-setting'
      , request
      , {headers: this.getAuthHeaders()}
    );
  }
}
